var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isString)?_c('span',{class:_vm.type},[_vm._v(_vm._s(_vm.processedText)+" ")]):_c('span',{staticClass:"italic"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.processedText))])])}
var staticRenderFns = []

export { render, staticRenderFns }